import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PurchaseOrderPurchaseAllocation } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderPoAllocationService extends TmsWebBaseEditCreateService<
  PurchaseOrderPurchaseAllocation,
  PurchaseOrderPurchaseAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderPoAllocation', $localize`Purchase Order Purchase Order Allocation`);
  }

  allocate(purchaseOrderLineId: string, purchaseOrderLineRequirementId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      purchaseOrderLineId,
      purchaseOrderLineRequirementId,
    });
  }

  updatePurchaseOrderPurchaseAllocation(purchaseOrderPurchaseAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdatePurchaseOrderPurchaseAllocation`, {
      purchaseOrderPurchaseAllocationId,
      quantity,
    });
  }
}
